module.exports = __webpack_public_path__ + "img/natudrin-depoimento-3.3184df41.jpg";